import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { Undo } from "../Icons";

import { DismissingCardContext } from "./DismissingCardContext";
import { UndoButton as Button } from "./styles";






export const UndoButton = ({ className, children }) => {
  const { undo } = useContext(DismissingCardContext);
  const theme = useContext(ThemeContext);

  return /*#__PURE__*/(
    React.createElement(Button, {
      small: true,
      className: className,
      onClick: undo,
      icon: /*#__PURE__*/React.createElement(Undo, { color: theme.colors['Level 5'] }) },

    children));


};